<template>
  <page :title="$tc('magazines.income')">
    <div slot="page-header-right">
      <div style="display: flex; align-items: center;">
        <a class="button mr-2" target="_blank">Export</a>
        <month-options @submit="time => replace(time)" @calculate="calculate" @reportDownload="reportDownload">
          <span class="ml-2">{{ dateRange }}</span>
        </month-options>
      </div>
    </div>
    <div class="box">
      <b-field>
        <b-input @blur="searchChanged()"
                 :placeholder="$tc('search.publisherMag')"
                 type="search"
                 v-model="query"
                 icon="magnify"
                 icon-clickable
                 @input="search => incomes.filter({ search }).load()"
                 expanded
        ></b-input>
      </b-field>

      <div class="card-content is-paddingless">
        <b-table
          :data="incomes.data"
          :loading="incomes.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="incomes.current_page"
          :per-page="incomes.per_page"
          :total="incomes.total"
          @page-change="page => incomes.changePage(page)"
          backend-sorting
          @sort="(field, direction) => incomes.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="magazine_id" label="#" sortable>
              {{ props.row.magazine_id }}
            </b-table-column>
            <b-table-column field="title" label="Magazine">
              <router-link
                :to="'/publishers/' + props.row.publisher_id"
                class="has-text-grey"
                size="is-large"
              >{{ props.row.publisher_name }}
              </router-link> /
              <router-link
                :to="'magazines/' + props.row.magazine_id + '/edit'"
                class="has-text-dark"
                size="is-large"
              >{{ props.row.magazine_name }}</router-link
              >

            </b-table-column>

            <b-table-column field="total_revenue" label="Total Revenue" sortable centered>
              $ {{ Math.round(props.row.total_revenue*100)/100 }}
            </b-table-column>
            <b-table-column field="magazine_opens" label="Total unique opens" sortable centered>
              <div >{{ props.row.magazine_opens }}</div>
            </b-table-column>

            <b-table-column>
              <div class="is-pulled-right">
                <router-link
                  class="button mr-2"
                  :to="`/magazine/incomes/${props.row.magazine_id}`"
                >Detail
                </router-link>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
import MonthOptions from "@/components/MonthOptions";
import InteractsWithQueryString from "@/core/InteractsWithQueryString";

export default {
  components: {
    MonthOptions
  },
  mixins: [InteractsWithQueryString],

  created() {
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    if (!this.$route.query.month) {
      this.replaceQuery("month", monthNames[new Date().getMonth()]);
    }

    if (!this.$route.query.year) {
      this.replaceQuery("year", new Date().getFullYear());
    }
  },

  data() {
    return {
      query: localStorage.getItem('download-search') || '',
      incomes: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/incomes"
      ).load()
    };
  },

  methods: {
    searchChanged() {
      localStorage.setItem('download-search', this.query);
    },

    replace(time) {
      if (this.$route.query.month !== time.month) {
        this.replaceQuery('month', time.month);
      }

      if (this.$route.query.year !== time.year) {
        this.replaceQuery('year', time.year);
      }
    },

    calculate() {
      this.$http
        .post(`/admin/api/magazine/calculate/income`, {
          'month': this.$route.query.month,
          'year': this.$route.query.year
        }).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });
      });
    },

    reportDownload() {
      this.$http
        .post(`/admin/api/magazine/report/download`, {
          'month': this.$route.query.month,
          'year': this.$route.query.year
        }).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });
      });
    },

    appleData() {
      this.$http
        .post(`/admin/api/magazine/transfer/income/apple`).then(() => {

        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });

        this.incomes.load();
      });
    },

    dataRecorded(message) {
      this.$buefy.toast.open({
        type: "is-success",
        message: message.message
      });
    },
  },

  computed: {
    dateRange() {
      return this.$route.query.month + " / " + this.$route.query.year;
    },
  },
};
</script>
